<template>
    <div class="column_center_center payment_type_popup">
        <div class="column_center_start payment_type_container">
            <text class="title" style="color: #FD5001; margin-bottom: 20px;">選擇付款方式</text>

            <!-- 付款方式單選 -->
            <div class="payment_radio_group">
                <label class="radio-option" v-if="linePayPaymentMethod"
                    :class="{ 'is-disabled': pointUsed }" @click="!pointUsed && selectPayment('linePay')">
                    <input v-model="selectedPaymentType" class="radio-input" type="radio" value="linePay" :disabled="pointUsed" />
                    <div class="picker" :class="{ selected: selectedPaymentType === 'linePay' }"></div>
                    <div class="row_center_center pay_badge">Pay</div>
                    <span>LinePay</span>
                </label>
                <label class="radio-option" v-if="isCashPaymentEnabled" @click="selectPayment('cash')">
                    <input v-model="selectedPaymentType" class="radio-input" type="radio" value="cash" />
                    <div class="picker" :class="{ selected: selectedPaymentType === 'cash' }"></div>
                    <span>店家自訂支付</span>
                </label>
            </div>

            <!-- 付款說明文字 -->
            <div v-if="isCashPaymentEnabled && customPaymentText" class="custom-payment-description mt-5">
                <div class="custom-payment-inner">
                    <div>店家自訂支付說明：</div>
                    <div v-html="customPaymentText"></div>
                </div>
            </div>
            
            <!-- 紅利積分折抵時，LINE Pay 不可用提示 -->
            <text v-if="linePayPaymentMethod && pointUsed"
                style="width: 85%; font-size: 14px; color: #FD5001; margin-top: 12px;">
                已使用紅利積分，無法使用LINEPAY結帳
            </text>

            <!-- 下方按鈕：返回 / 送出訂單 -->
            <div class="retail_action_row mt-5">
                <button class="button retail_cancel" @click="close">返回</button>
                <button class="button retail_submit" :disabled="!selectedPaymentType" @click="submitOrder">送出訂單</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        pointUsed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectedPaymentType: ''   // '' | 'linePay' | 'cash'
        }
    },
    computed: {
        geturlParameters() {
            return this.$route.params
        },
        linePayPaymentMethod() {
            return this.$store.getters['payment/linePayPaymentMethod']
        },
        isCashPaymentEnabled() {
            return this.$store.getters['payment/isCashPaymentEnabled']
        },
        customPaymentText() {
            return this.$store.getters['basic/customPaymentText']
        }
    },
    methods: {
        close() {
            this.$emit("close")
        },
        selectPayment(type) {
            this.selectedPaymentType = type
        },
        submitOrder() {
            if (!this.selectedPaymentType) return
            if (this.selectedPaymentType === 'linePay') {
                this.$emit("linePay")
            } else {
                this.$emit("cashPay")
            }
            this.$emit("close")
        }
    },
}
</script>
<style lang="scss">
/* 遮罩 / 容器 / .button / .custom-payment-* 沿用 paymentTypePopup.vue 的全域 scss */

/* 單選群組（沿用 takeOutEdit.vue 的 radio 樣式） */
.payment_radio_group {
    width: 85%;
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.payment_radio_group .radio-option {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 18px;
    font-weight: 500;
    color: #000;
    cursor: pointer;
    user-select: none;
}

.payment_radio_group .radio-option.is-disabled {
    opacity: 0.4;
    pointer-events: none;
}

.payment_radio_group .radio-input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}

.payment_radio_group .picker {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 1px solid #AAAAAA;
    flex-shrink: 0;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.payment_radio_group .picker.selected {
    border-color: #FACB00;
    border-width: 2px;
}

.payment_radio_group .picker.selected::before {
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: #FACB00;
}

/* LinePay 小綠底「Pay」標記 */
.payment_radio_group .pay_badge {
    padding: 3px 7px;
    background-color: #03BF5B;
    color: #fff;
    border-radius: 4px;
    font-weight: 900;
    font-size: 14px;
}

/* 下方取消 / 送出訂單 */
.retail_action_row {
    width: 85%;
    display: flex;
    justify-content: space-between;
    gap: 12px;
}

.retail_action_row .button {
    width: 50%;
    margin: 0;
}

.retail_cancel {
    background-color: #DDDDDD;
}

.retail_submit {
    background-color: #FACB00;
    color: #fff;
}

.retail_submit:disabled {
    background-color: #FACB00;
    opacity: 0.7;
}
</style>
